import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  lookupDepartmentNameById,
  activeEditDepartment,
} from '../../../actions/lookups';
import {
  updateEditDepartment,
  updateDepartmentOrder,
  deleteDepartment,
} from '../../../actions/apiDepartmentUpdates';
import {
  setCurrentTab,
  setEditDepartmentCurrentTab,
} from '../../../actions/apiSetInfo';
import DeleteDepartmentButton from './DeleteDepartmentButton';
import EditDepartmentOrder from '../../../inputs/EditDepartmentOrder';
import EditDepartmentSettings from '../../../inputs/EditDepartmentSettings';
import TabEditDepartmentColors from './TabEditDepartmentColors';
import TabEditDepartmentProperties from './TabEditDepartmentProperties';
import TabEditDepartmentFilters from './TabEditDepartmentFilters';

const DepartmentListItem = () => {
  const dispatch = useDispatch();
  const edit_department = useSelector((state) => state.settings_admin.edit_department);
  const edit_department_current_tab = useSelector(
    (state) => state.settings_admin.edit_department_current_tab,
  );

  const handleTabClick = useCallback(
    (tabName) => {
      dispatch(setEditDepartmentCurrentTab(tabName));
    },
    [dispatch],
  );

  const handleClick = useCallback(() => {
    dispatch(activeEditDepartment(edit_department.id));
    if (!edit_department_current_tab) {
      dispatch(setCurrentTab('default-department-columns'));
    }
    window.scrollTo(0, 0);
  }, [dispatch, edit_department.id, edit_department_current_tab]);

  const deleteDepartment = useCallback(
    (id) => {
      const name = dispatch(lookupDepartmentNameById(id));
      const data = {
        id,
        active: false,
        name: `deleted_${Math.floor(1000 + Math.random() * 9000)}_${name}`,
      };
      dispatch(updateEditDepartment(0));
      dispatch(deleteDepartment(id, data, 'deleteDepartmentError'));
    },
    [dispatch],
  );

  const updateDepartmentOrders = useCallback(
    (e) => {
      dispatch(updateDepartmentOrder(e, 'updateDepartmentOrders'));
    },
    [dispatch],
  );

  const selectDealers = (dealerships) => {
    if (!dealerships) return [];
    return dealerships.split(',').map((option) => ({
      value: option,
      label: option,
    }));
  };

  useEffect(() => {
    if (edit_department.id) {
      handleClick();
    }
  }, [edit_department.id, handleClick]);

  const dealerships = edit_department.dealerships || '';
  const dealers = selectDealers(dealerships);

  return (
    <div className="container row space-top-0">
      <div className="col">
        <ul className="nav nav-pills nav-fill pad-bottom-1" role="tablist">
          <li className="nav-item">
            <a
              className={
                edit_department_current_tab === 'edit-department-settings'
                  ? 'nav-link active'
                  : 'nav-link'
              }
              name="edit-department-settings"
              onClick={() => handleTabClick('edit-department-settings')}
            >
              Edit {edit_department.name} Settings
            </a>
          </li>
          <li className="nav-item">
            <a
              className={
                edit_department_current_tab === 'edit-department-columns'
                  ? 'nav-link active'
                  : 'nav-link'
              }
              name="edit-department-columns"
              onClick={() => handleTabClick('edit-department-columns')}
            >
              Add/Edit {edit_department.name} Columns
            </a>
          </li>
          <li className="nav-item">
            <a
              className={
                edit_department_current_tab === 'edit-department-colors'
                  ? 'nav-link active'
                  : 'nav-link'
              }
              name="edit-department-colors"
              onClick={() => handleTabClick('edit-department-colors')}
            >
              Colors
            </a>
          </li>
          <li className="nav-item">
            <a
              className={
                edit_department_current_tab === 'edit-department-filters'
                  ? 'nav-link active'
                  : 'nav-link'
              }
              name="edit-department-filters"
              onClick={() => handleTabClick('edit-department-filters')}
            >
              Filters
            </a>
          </li>
        </ul>
        <div className="container-fluid pad-left-0 pad-right-0">
          <div
            className={
              edit_department_current_tab === 'edit-department-settings'
                ? 'tab-box active'
                : 'tab-box'
            }
          >
            <div className="col-md-6 space-top-0 text-dark">
            <div className="card w-100">
            <div className="card-body">
                <h5 className="card-title"> <label className="label pad-2">Edit Department Name (lowercase)</label></h5>
                <EditDepartmentSettings
                key={`settings_name_${edit_department.id}`}
                parentid={edit_department.id}
                name="name"
                label="Name"
                type="text"
                value={edit_department.name}
              />
            </div>
            </div>

            <div className="card w-100">
            <div className="card-body">
                <h5 className="card-title"> <label className="label pad-2">Edit Display Name (any case and characters allowed)</label></h5>
                <EditDepartmentSettings
                key={`settings_display_name_${edit_department.id}`}
                parentid={edit_department.id}
                name="display_name"
                label="Display Name"
                type="text"
                value={edit_department.display_name}
              />
            </div>
            </div>

            <div className="card w-100">
            <div className="card-body">
                <h5 className="card-title"><label className="label pad-2">Nest Under Parent Step</label></h5>
                <EditDepartmentSettings
                key={`settings_subgroup_${edit_department.id}`}
                checked={false}
                parentid={edit_department.id}
                name="subgroup"
                label="Subgroup Parent"
                type="select-subgroup"
                value={edit_department.subgroup}
              />
            </div>
            </div>
            </div>
            <div className="col-md-6 space-top-0 text-dark">

            <div className="card w-100">
            <div className="card-body">
                <h5 className="card-title"><label className="label pad-2">Transfer To New Location:</label></h5>
                <EditDepartmentSettings
                key={`settings_trasfer_subdomain_${edit_department.id}`}
                checked={false}
                parentid={edit_department.id}
                name="subdomain"
                label="Trasfer Vehicle To"
                type="select-related-installations"
                value={edit_department.subdomain}
              />
            </div>
            </div>

            <div className="card w-100">
            <div className="card-body">
                <h5 className="card-title"><label className="label pad-2">Transfer To New Location's Department:</label></h5>
                <EditDepartmentSettings
                key={`settings_subdomain_department_${edit_department.id}`}
                checked={false}
                parentid={edit_department.id}
                name="subdomain_department"
                label="Set Transfer Department"
                type="select-departments"
                value={edit_department.subdomain_department}
              />
            </div>
            </div>
            </div>
          </div>
          <div
            className={
              edit_department_current_tab === 'edit-department-colors'
                ? 'tab-box active'
                : 'tab-box'
            }
          >
            <TabEditDepartmentColors edit_department={edit_department} />
          </div>
          <div
            className={
              edit_department_current_tab === 'edit-department-columns'
                ? 'tab-box active'
                : 'tab-box'
            }
          >
            <TabEditDepartmentProperties />
          </div>
          <div
            className={
              edit_department_current_tab === 'edit-department-filters'
                ? 'tab-box active'
                : 'tab-box'
            }
          >
            <TabEditDepartmentFilters />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepartmentListItem;